(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bedtime-clear-cart"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bedtime-clear-cart')) {
    let clearing = false;
    customElements.define('bedtime-clear-cart', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const button = this.querySelector('button');
        const dialog = this.querySelector('dialog');
        button.hidden = false;
        button.addEventListener('click', () => { if (!clearing) dialog.showModal(); });
        this.querySelector('[data-cancel]').addEventListener('click', () => dialog.close());
        dialog.addEventListener('close', () => button.focus());
        this.querySelector('[data-confirm-clear]').addEventListener('click', async () => {
          if (clearing) return;
          dialog.close();
          clearing = true;
          const label = button.textContent;
          const message = this.querySelector('[role="status"]');
          document.querySelectorAll('bedtime-clear-cart button').forEach(item => { item.disabled = true; });
          button.textContent = this.dataset.loading;
          message.textContent = '';
          this.setAttribute('aria-busy', 'true');
          try {
            const response = await fetch(this.dataset.cartUrl + '/clear.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: '{}'
            });
            if (!response.ok) throw new Error();
            const cart = await response.json();
            if (cart.item_count !== 0 || !Array.isArray(cart.items) || cart.items.length !== 0) throw new Error();
            const destination = new URL(this.dataset.cartUrl, window.location.origin);
            const preview = new URL(window.location.href).searchParams.get('preview_theme_id');
            if (preview) destination.searchParams.set('preview_theme_id', preview);
            window.location.assign(destination.href);
          } catch {
            message.textContent = this.dataset.error;
            clearing = false;
            this.removeAttribute('aria-busy');
            button.textContent = label;
            document.querySelectorAll('bedtime-clear-cart button').forEach(item => { item.disabled = false; });
          }
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
